/* "Buy it now": adds the selected variant (and quantity) to the cart and goes straight to checkout. */
(() => {
  if (window.__ntBuyNow) return;
  window.__ntBuyNow = true;

  const sync = () => {
    document.querySelectorAll('[data-nt-buynow-btn]').forEach((btn) => {
      const atc = btn.closest('form')?.querySelector('[name="add"]');
      if (!atc) return;
      const off = atc.hasAttribute('disabled');
      if (off !== btn.hasAttribute('disabled')) btn.toggleAttribute('disabled', off);
    });
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-nt-buynow-btn]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    const form = btn.closest('form');
    if (!form) return;
    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      const data = new FormData(form);
      const qtyInput = document.querySelector('input[name="quantity"][form="' + btn.dataset.form + '"]') || form.querySelector('input[name="quantity"]');
      if (qtyInput && !data.get('quantity')) data.set('quantity', qtyInput.value);
      data.delete('add');
      /* Add-ons (e.g. FREE kits in <nt-upsell>) are normally added on form submit; Buy it now skips submit, so add the ticked ones here first. */
      const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      const upsells = Array.prototype.slice.call(document.querySelectorAll('nt-upsell')).filter((u) => u.dataset.form === form.id);
      if (upsells.length) {
        let inCart = [];
        try { const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); inCart = (c.items || []).map((i) => Number(i.variant_id)); } catch (e) {}
        const extra = [];
        upsells.forEach((u) => {
          const q = u.dataset.matchQuantity === 'true' ? (Number(data.get('quantity')) || 1) : 1;
          u.querySelectorAll('[data-nt-addon]').forEach((row) => {
            const c = row.querySelector('[data-nt-addon-check]');
            const id = Number(row.dataset.variantId);
            if (c && c.checked && id && inCart.indexOf(id) === -1) extra.push({ id: id, quantity: q });
          });
        });
        if (extra.length) {
          const r2 = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: extra }) });
          if (!r2.ok) throw new Error('add-ons failed');
        }
      }
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (e) {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      const err = form.closest('product-form')?.querySelector('.product-form__error-message');
      if (err) { err.textContent = (window.cartStrings && window.cartStrings.error) || 'Could not add this item.'; err.closest('[role="alert"]')?.removeAttribute('hidden'); }
    }
  });

  new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true });
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
